import { cfgMegajackpotFeed } from '@infinitro/config';
import { formatJackpotCurrency, getJackpotCurrencySetting } from './jackpot-format';
const MEGAJACKPOT_BASE_URL = 'https://vip.fghjk.net/megajackpot/feed/jackpotdata';
const POLL_INTERVAL_MS = 30_000;
export const jackpotMEGA = $state({ value: formatJackpotCurrency(0, getJackpotCurrencySetting()) });
const getMegajackpotFeedUrl = () => {
    const feed = cfgMegajackpotFeed();
    if (!feed) {
        return null;
    }
    const params = new URLSearchParams({
        operator: feed.operator,
        hash: feed.hash
    });
    if (feed.currency) {
        params.set('currency', feed.currency);
    }
    return `${MEGAJACKPOT_BASE_URL}?${params.toString()}`;
};
const fetchMegajackpotMega = async (url) => {
    try {
        const res = await fetch(url);
        if (!res.ok) {
            console.warn(`Megajackpot feed request failed: ${res.status} ${res.statusText}`);
            jackpotMEGA.value = formatJackpotCurrency(0, getJackpotCurrencySetting());
            return;
        }
        const data = await res.json();
        const value = data?.jackpots?.MEGA_VALUE ?? 0;
        jackpotMEGA.value = formatJackpotCurrency(value, getJackpotCurrencySetting());
    }
    catch (error) {
        console.warn('Megajackpot feed request failed', error);
        jackpotMEGA.value = formatJackpotCurrency(0, getJackpotCurrencySetting());
    }
};
export const startMegajackpotPolling = () => {
    const url = getMegajackpotFeedUrl();
    if (!url) {
        console.warn('Megajackpot feed URL not found');
        return () => { };
    }
    void fetchMegajackpotMega(url);
    const intervalId = setInterval(() => {
        void fetchMegajackpotMega(url);
    }, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
};
